import { ChangeDetectionStrategy, Component, input, OnInit, signal } from '@angular/core';
import { CloudStorageBannerWidget, CloudStorageStatus } from '@core/models';
import { environment } from '@src/environments/environment';
import { StorageService } from '@core/services';
import { Store } from '@ngrx/store';
import { userFeature } from '@state';
import { filter, switchMap, take, tap } from 'rxjs/operators';
import { ButtonComponent } from '../button/button.component';
import { CmsImagePipe } from '@selfcare/cms';
import { GeneralActions, generalFeature } from '@src/state/general';

@Component({
  selector: 'sc-cloud-storage-banner-widget',
  imports: [CmsImagePipe, ButtonComponent],
  templateUrl: './cloud-storage-banner-widget.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CloudStorageBannerWidgetComponent implements OnInit {
  data = input<CloudStorageBannerWidget>(null);
  createAccountUrl = signal<string>(null);
  status = signal<CloudStorageStatus>(null);
  user = this.store.selectSignal(userFeature.selectCurrent);
  CloudStorageStatus = CloudStorageStatus;

  public isJottaInUse = this.store.selectSignal(userFeature.selectIsJottaInUse);
  public storagePrice = this.store.selectSignal(generalFeature.selectStoragePrice);

  constructor(
    private readonly store: Store,
    private readonly apiService: StorageService
  ) {}

  public getBackgroundStyle() {
    if (!this.data().primaryBackgroundImage) {
      return '';
    }
    return `linear-gradient(110.46deg, rgba(0, 0, 0, 0) -72.27%, #000000 108.19%), url(${environment.cms.apiUrl}${this.data().primaryBackgroundImage.url})`;
  }

  public ngOnInit() {
    this.store
      .select(userFeature.selectCurrent)
      .pipe(
        filter((user) => !!user),
        take(1),
        tap((user) => {
          this.status.set(user.storageState as CloudStorageStatus);
        }),
        switchMap(() => this.apiService.getCloudStorageUrl()),
        tap((urlResponse) => this.createAccountUrl.set(urlResponse.url))
      )
      .subscribe();

    this.store.dispatch(GeneralActions.getStoragePrice());
  }
}
